import {asset} from 'imba';
import url from './info.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24ZM22 35C22 36.1046 22.8954 37 24 37C25.1046 37 26 36.1046 26 35V21C26 19.8954 25.1046 19 24 19C22.8954 19 22 19.8954 22 21V35ZM24 15C22.8954 15 22 14.1046 22 13C22 11.8954 22.8954 11 24 11C25.1046 11 26 11.8954 26 13C26 14.1046 25.1046 15 24 15Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})